module.exports = __webpack_public_path__ + "img/horse-stable.21de351e.png";